import { render } from "./KpiSave.vue?vue&type=template&id=f93b79d6&scoped=true"
import script from "./KpiSave.vue?vue&type=script&lang=js"
export * from "./KpiSave.vue?vue&type=script&lang=js"

import "./kpi.scss?vue&type=style&index=0&id=f93b79d6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f93b79d6"]])

export default __exports__